import React, { useState } from "react";
import { Tabs } from 'antd';
import { useNavModel, RouterParamType } from "@src/model/navModel";
import { globalPrompt } from "@src/components/YhMessage";
import { BasicInfo } from './BasicInfo';
import { EmployeeInfo } from './EmployeeInfo';
import { ContractInfo } from './ContractInfo';
import { WorkExperience } from './WorkExperience';
import { SalaryFile } from './SalaryFile';
import { OtherInfo } from './OtherInfo';
import { YhAuth } from "@src/components/auth/YhAuth";
import useGlobalModel from "@src/model/globalModel";
import "../../rosterStyles.less";

export const RosterDetails = () => {
    const { getSelectedNavState } = useNavModel();
    const { resourceAuth } = useGlobalModel(model => [model.resourceAuth]);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id, mode, activeKey } = detailsInfo;
    const [tabActives, setTabActives] = useState<string>(activeKey);


    const hasAuth = (resCode: string): boolean => {
        const result = !!resourceAuth.find(item => item === resCode);
        return result;
    };

    const renderTabContent = (key: string) => {
        switch (key) {
            case "1": return <BasicInfo />;
            case "2": return <EmployeeInfo />;
            case "3": return <ContractInfo />;
            case "4": return <WorkExperience />;
            case "5": return <SalaryFile />;
            case "6": return <OtherInfo />;
            default: return null;
        }
    };

    return (
        <div style={{ display: "flex" }}>
            <div style={{ flex: 1, height: 700, paddingTop: 50, backgroundColor: "#FFFFFF" }}>
                <Tabs tabPosition={"left"} defaultActiveKey={activeKey} onChange={(e) => { setTabActives(e) }}>
                    <Tabs.TabPane tab="基本信息" key="1" />
                    {mode === "edit" && hasAuth("portal2.au.roster.employeeinfo") && (
                        <Tabs.TabPane tab="员工信息" key="2" />
                    )}
                    {mode === "edit" && hasAuth("portal2.au.roster.contractinfo") && (
                        <Tabs.TabPane tab="合同信息" key="3" />
                    )}
                    {mode === "edit" && hasAuth("portal2.au.roster.workexperience") && (
                        <Tabs.TabPane tab="工作经历" key="4" />
                    )}
                    {mode === "edit" && hasAuth("portal2.au.roster.salaryfile") && (
                        <Tabs.TabPane tab="薪酬档案" key="5" />
                    )}
                    {mode === "edit" && hasAuth("portal2.au.roster.otherinfo") && (
                        <Tabs.TabPane tab="其他信息" key="6" />
                    )}
                </Tabs>
            </div>
            <div className="detail" style={{ flex: 10, height: 700 }}>
                {renderTabContent(tabActives)}
            </div>
        </div>
    );
}